import React from 'react'

import { ZentakeLogo } from '@/components/Svg/ZentakeLogo'

function AuthCard({ children, wide }) {
  return (
    <div className="flex h-screen flex-1 items-center justify-center">
      <div
        className="w-100 mx-2 grid max-w-screen-sm grid-cols-1 rounded border-none bg-white p-4 !shadow-lg"
        style={wide ? {} : { maxWidth: '446px' }}
      >
        <div className="mb-3 flex flex-1 justify-center">
          <ZentakeLogo className="my-3" width={170} />
        </div>
        {children}
      </div>
    </div>
  )
}

export default AuthCard
